import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { Link } from 'react-router';
import moment = require('moment');
import { Tags } from 'components/Magazine/Article/Tag/Tags';

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

interface IState {
	hoverArticle: boolean[];
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType8 extends React.Component<IProps, IState, any> {
	constructor(props) {
		super(props);

		this.state = {
			hoverArticle: [false, false],
		};
	}

	private renderItem(n: number) {
		const { elements } = this.props.section.data;
		const tags = (elements[n + 2] as ISectionTextElement).tags;

		const handleMouseEvent = (n: number, hover: boolean) => {
			const newHoverArticle = this.state.hoverArticle.map((currentState, index) =>
				n / 3 === index ? hover : currentState,
			); // if index is equal to n / 3 it means that this is the element we hovered/mouse entered

			this.setState({ hoverArticle: newHoverArticle });
		};

		return (
			<>
				<Link
					to={(elements[n] as ISectionImageElement).redirectUrl}
					className={`imageSmall ${this.state?.hoverArticle[n / 3] ? 'hoverImage' : ''}`}
					style={{
						backgroundImage: `url(${(elements[n] as ISectionImageElement).imageUrl})`,
					}}
					onMouseEnter={() => handleMouseEvent(n, true)}
					onMouseLeave={() => handleMouseEvent(n, false)}
				/>
				<div className="bottomText">
					<Tags tags={tags} onClick={true} displayNumber={4} />
					<Link to={(elements[n] as ISectionImageElement).redirectUrl}>
						<h1
							className={`text title ${this.state?.hoverArticle[n / 3] ? 'hoverTitle' : ''}`}
							title={(elements[n + 1] as ISectionTextElement).text}
							onMouseEnter={() => handleMouseEvent(n, true)}
							onMouseLeave={() => handleMouseEvent(n, false)}
						>
							{(elements[n + 1] as ISectionTextElement).text}
						</h1>
					</Link>

					<div className="info">
						<p className="p12 text author">{(elements[n + 2] as ISectionTextElement).text}</p>
						<span>&#8226;</span>
						<p className="p12 text gray date">{moment((elements[n + 2] as ISectionTextElement).date).format('L')}</p>
					</div>
				</div>
			</>
		);
	}

	public render() {
		const { elements } = this.props.section.data;

		return (
			<div className="container sectionType8container">
				<h1 className="sectionTitle">{(elements[6] as ISectionTextElement).text}</h1>
				<div className="row desktopShown">
					<div className="col-lg-6 col-md-12 no_pad">{this.renderItem(0)}</div>
					<div className="col-lg-6 col-md-12 no_pad">{this.renderItem(3)}</div>
				</div>
			</div>
		);
	}
}

export { ViewType8 };
